import { Grid, Typography } from '@mui/material';
import styled from '@emotion/styled';
import { theme } from 'config';

export const StatusWrapper = styled(Grid)({});

export const Point = styled(Grid)(
  {
    minWidth: '15px',
    height: '15px',
    borderRadius: '50%',
    marginRight: '10px',

    [theme.breakpoints.down('sm')]: {
      marginRight: '5px',
    },
  },
  ({ color }) => ({
    backgroundColor: color,
  })
);

export const Title = styled(Typography)(
  {
    // textTransform: 'capitalize',
  },
  ({ list }) => ({ fontSize: list === 'true' ? '14px' : '12px' })
);

export const StatusDate = styled(Typography)({
  fontSize: '14px',
  marginLeft: '5px',
});
